import { render, staticRenderFns } from "./PaymentMethodeDelete.vue?vue&type=template&id=806d0fb4&scoped=true&"
import script from "./PaymentMethodeDelete.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodeDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806d0fb4",
  null
  
)

export default component.exports